export class MetaElementPlausiPropertyDef {
  public static readonly IS_SENSOR_CURRENT_CHANNEL: string = 'isSensorCurrentChannel';
  public static readonly IS_LOGIC_CURRENT_CHANNEL: string = 'isLogicCurrentChannel';
  public static readonly IS_ACTUATOR_CURRENT_CHANNEL: string = 'isActuatorCurrentChannel';
  public static readonly SPANNUNG_IO: string = 'Spannung_IO_750_753';
}
